import { Injectable } from '@angular/core';
import { BaseServiceFacade, GenericApiCall } from '../../../common/store/types';
import { Store } from '@ngrx/store';
import { AppState } from '../types';
import { MediumModel } from './types';
import { mediumActions } from './medium.action';
import { mediumSelectors } from './medium.selector';
import { ListItem } from '../typeahead/types';

@Injectable()
export class MediumService extends BaseServiceFacade {
  constructor(store: Store<AppState>) {
    super(store);
  }

  getById: GenericApiCall<MediumModel, string> = this.genericApiCall(
    mediumActions.getById,
    mediumSelectors.getById,
    true,
  );

  getList: GenericApiCall<ListItem[], void> = this.genericApiCall(
    mediumActions.getList,
    mediumSelectors.getList,
    true,
  );

  add: GenericApiCall<MediumModel, MediumModel> = this.genericApiCall(
    mediumActions.add,
    mediumSelectors.add,
    true,
  );

  update: GenericApiCall<MediumModel, MediumModel> = this.genericApiCall(
    mediumActions.update,
    mediumSelectors.update,
    true,
  );
}
